import { render, staticRenderFns } from "./ChatAreaThreeDotMenu.vue?vue&type=template&id=dda4eb86&scoped=true&"
import script from "./ChatAreaThreeDotMenu.vue?vue&type=script&lang=js&"
export * from "./ChatAreaThreeDotMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChatAreaThreeDotMenu.vue?vue&type=style&index=0&id=dda4eb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda4eb86",
  null
  
)

export default component.exports